import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import { CraneUiI18nProvider, ToastProvider } from '@asad/crane-ui'

import '@asad/ui/dist/index.css'

import './index.css'
import { AppRouter } from './components/router/app-router'
import { ToastBridge } from './controllers/toast-bridge'
import { usePWA } from './hooks'
import { DrawerProvider } from './context/DrowerContext'
import i18n from './i18n'
import DrawerWrapper from './components/drawer/DrawerWrapper'

const App = () => {
  const { t } = useTranslation()
  const translate = React.useCallback((key: string, options?: Record<string, unknown>) => t(key, options), [t])

  React.useEffect(() => {
    const savedLanguage = localStorage.getItem('lng') || 'pl'
    i18n.changeLanguage(savedLanguage)
  }, [])

  usePWA()

  return (
    <CraneUiI18nProvider t={translate}>
      <ToastProvider>
        <ToastBridge />
        <meta name='theme-color' />
        <HelmetProvider>
          <DrawerProvider>
            <AppRouter />
            <DrawerWrapper />
          </DrawerProvider>
        </HelmetProvider>
      </ToastProvider>
    </CraneUiI18nProvider>
  )
}

export default App
